import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import { crmHeaders } from "../../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function AddSmsTemplate() {
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        axios
            .get(`${BASE_URL}/getcountries`, { headers: crmHeaders() })
            .then((res) => setCountries(res.data))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const country = formData.get("country");
        const template = formData.get("template");

        if (!country || !template?.trim()) {
            toast.error("Country and template are required");
            return;
        }

        setSubmitting(true);
        axios
            .post(
                `${BASE_URL}/sms/templates`,
                { Country: country, Template: template.trim() },
                { headers: crmHeaders() }
            )
            .then(() => {
                toast.success("SMS template added");
                navigate("/sms/templates");
            })
            .catch((err) => toast.error(err.response?.data?.message || "Failed to add template"))
            .finally(() => setSubmitting(false));
    };

    if (loading) return <Loader />;

    return (
        <div className="container">
            <ToastContainer />
            <div className="crm-page-header">
                <h1 className="crm-page-title">Add SMS Template</h1>
                <Link to="/sms/templates" className="btn btn-outline-secondary">
                    Back
                </Link>
            </div>

            <form onSubmit={handleSubmit} className="crm-user-form-card-body">
                <div className="mb-3">
                    <label className="form-label">Country</label>
                    <select className="form-select" name="country" required defaultValue="">
                        <option value="" disabled>
                            Select country
                        </option>
                        {countries
                            .filter((c) => c.Status === "Active")
                            .map((c) => (
                                <option key={c.Id} value={c.Country}>
                                    {c.Country}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">Message Template</label>
                    <textarea
                        className="form-control"
                        name="template"
                        rows={6}
                        required
                        placeholder="Hi {clientName}, this is regarding {businessName}. Reply to this number for help."
                    />
                    <small className="text-muted">
                        Placeholders: {"{clientName}"}, {"{businessName}"}, {"{phoneNumber}"}, {"{email}"}
                    </small>
                </div>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                    {submitting ? "Saving..." : "Save Template"}
                </button>
            </form>
        </div>
    );
}
